import { m } from 'framer-motion';

import { cn } from 'src/lib/utils';
import { Spinner } from 'src/components/ui/spinner';

// ----------------------------------------------------------------------

interface LoadingScreenProps {
  className?: string;
}

/**
 * Page-transition loading state: the shared conic-arc Spinner over a quiet,
 * breathing "Loading" label. Uses semantic theme tokens so it adapts to
 * light/dark mode.
 */
export default function LoadingScreen({ className }: LoadingScreenProps) {
  return (
    <div className={cn('relative flex min-h-0 flex-1 items-center justify-center', className)}>
      <div className="flex flex-col items-center gap-8">
        <Spinner className="size-14" />

        {/* Breathing "Loading" label */}
        <m.p
          className="text-xs font-medium uppercase tracking-[0.25em] text-muted-foreground"
          animate={{ opacity: [0.3, 0.7, 0.3] }}
          transition={{
            duration: 2.5,
            ease: 'easeInOut',
            repeat: Infinity,
          }}
        >
          Loading
        </m.p>
      </div>
    </div>
  );
}
